/*
 * トップページのジャンボトロン(sections/hero-slider.liquid)をslickでスライダー化する。
 *
 * 管理画面の「カスタマイズ」ではセクションが再描画されるため、
 * 通常のページ読み込み時に加えて、テーマエディタのイベントでも初期化・操作を行う。
 * https://shopify.dev/docs/storefronts/themes/best-practices/editor/integrate-sections-and-blocks
 */
(function ($) {
  if (window.heroSliderLoaded) return;
  window.heroSliderLoaded = true;

  function init(container) {
    $(container)
      .find('[data-hero-slider]')
      .each(function () {
        var $slider = $(this);
        if ($slider.hasClass('slick-initialized')) return;

        $slider.slick({
          dots: true,
          arrows: true,
          prevArrow: '<div class="pickup-prev"></div>',
          nextArrow: '<div class="pickup-next"></div>',
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: $slider.data('autoplay') === true,
          autoplaySpeed: Number($slider.data('autoplay-speed')) || 3000,
        });
      });
  }

  function destroy(container) {
    $(container)
      .find('[data-hero-slider].slick-initialized')
      .slick('unslick');
  }

  $(function () {
    init(document);
  });

  // 以下はテーマエディタ専用のイベント
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });

  // 管理画面でスライドを選択したら、そのスライドを表示して自動再生を止める
  document.addEventListener('shopify:block:select', function (event) {
    var $slide = $(event.target).closest('.slick-slide');
    var $slider = $slide.closest('[data-hero-slider]');
    if (!$slider.length) return;
    $slider.slick('slickPause');
    $slider.slick('slickGoTo', Number($slide.attr('data-slick-index')));
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var $slider = $(event.target).closest('[data-hero-slider]');
    if (!$slider.length || $slider.data('autoplay') !== true) return;
    $slider.slick('slickPlay');
  });
})(jQuery);
